import { render, staticRenderFns } from "./ChengXinCompany.vue?vue&type=template&id=8aa155f0&scoped=true&"
import script from "./ChengXinCompany.vue?vue&type=script&lang=js&"
export * from "./ChengXinCompany.vue?vue&type=script&lang=js&"
import style0 from "./ChengXinCompany.vue?vue&type=style&index=0&id=8aa155f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa155f0",
  null
  
)

export default component.exports